import { useBreakpointValue } from 'native-base'
import BrowserRoom from '../components/room30/BrowserRoom'
import MobileRoom from '../components/room30/MobileRoom'
import secureScreen from '../hooks/authentication/secureScreen'

const RoomScreen30 = () => {
  const breakpoint = useBreakpointValue({
    base: 'mobile',
    lg: 'browser',
  })

  return breakpoint === 'mobile' ? <MobileRoom /> : <BrowserRoom />
}

export default secureScreen(RoomScreen30)
